var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.125a6.375 6.375 0 100 12.75 6.375 6.375 0 000-12.75zM.208 8.5a7.792 7.792 0 1115.584 0 7.792 7.792 0 01-15.584 0z",
    fill: "#007F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.542c.391 0 .709.317.709.708v3.812l2.441 1.221a.708.708 0 11-.633 1.267L7.683 9.134a.708.708 0 01-.391-.634V4.25c0-.391.317-.708.708-.708z",
    fill: "#007F33"
  })));
}
export default SvgClock;